import React, { useEffect, useState } from "react";
import axios from "axios";
import "./about.css";
import ArticleContent from "../../components/articlecontent/ArticleContent";

const About = () => {
  const [aboutBlog, setAboutBlog] = useState({});
  const [authors, setAuthors] = useState([]);

  useEffect(() => {
    const getAboutBlog = async () => {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/blog-infos?populate[about_photo]=true"
        // {
        //   headers: {
        //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
        //   },
        // }
      );
      //only getting the first entry of the table
      setAboutBlog(res.data.data[0]);
    };
    const getAuthorBios = async () => {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/authors?populate[author_img]=true"
        // {
        //   headers: {
        //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
        //   },
        // }
      );
      //only getting the first entry of the table
      setAuthors(res.data.data);
    };
    getAboutBlog();
    getAuthorBios();
  }, []);

  return (
    <div className="aboutContainer">
      <div className="aboutBlogContainer">
        <div
          className="d-flex align-items-center justify-content-start bg-cover bg-center text-white position-relative mb-2 intro-img"
          style={{
            backgroundImage: `url(${process.env.REACT_APP_UPLOAD_URL}${aboutBlog.about_photo?.url})`,
            height: "30vh", // or whatever height you want
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* <img
            className="singlePostImg"
            src={`${process.env.REACT_APP_UPLOAD_URL}${aboutBlog.about_photo?.url}`}
            alt=""
          /> */}
          <div className="d-flex flex-column z-3 position-relative ps-5">
            <h1 className="singlePostTitle">{aboutBlog.title}</h1>
          </div>
        </div>

        {/* <h1 className="singlePostTitle">{aboutBlog.title}</h1> */}
        <p className="singlePostDesc">{aboutBlog.description}</p>
        {aboutBlog.long_desc && (
          <ArticleContent content={aboutBlog.long_desc} />
        )}
      </div>

      {/* Author Bios */}
      {authors.map((author, i) => (
        <div key={"author-" + i}>
          <img
            className="singlePostImg"
            src={`${process.env.REACT_APP_UPLOAD_URL}${author.author_img?.url}`}
            alt=""
          />
          <h2>{author.name}</h2>
          <p>{author.bio}</p>
        </div>
      ))}
    </div>
  );
};

export default About;
